import { render, staticRenderFns } from "./MarkedIcon.vue?vue&type=template&id=b9837792&scoped=true&"
import script from "./MarkedIcon.vue?vue&type=script&lang=js&"
export * from "./MarkedIcon.vue?vue&type=script&lang=js&"
import style0 from "./MarkedIcon.vue?vue&type=style&index=0&id=b9837792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9837792",
  null
  
)

export default component.exports